import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import InvestmentPlanDetalis from "./Investment/InvestmentPlanDetalis";
import TaxSaving from "./Investment/TaxSaving";
import ShareCode from "./Investment/ShareCode/ShareCode";
import InvestmentCompareBox from "./Investment/InvestmentCompareBox";
import SMCInvestmentCompare from "./Investment/SMCInvestmentCompare";
import Investment from "./Investment/Investment";
import SMCInvestmentQuotes from "./Investment/SMCInvestmentQuotes";
import InvestmentProposal from './Investment/InvestmentProposal';
import './Investment/Investment.css';
import axios from 'axios';
import { NavMenu } from './components/NavMenu';
import WhatsAppBot from './components/whatsappbot/WhatsAppBot';
import "./components/css/Header.css";
import { ToastContainer, Bounce } from 'react-toastify';

const App = () => {
    const [IsHideDash, setDeshBoard] = useState(true);
    const [UserData, setUserData] = useState("");
    const [cookies, setCookies] = useState();
    const [showWhatsAppBot, setWhatsAppBot] = useState(false);

    useEffect(() => {
        const allCookies = getCookies();
        if (allCookies.priviledge) {
            try {
                const obj = JSON.parse(atob(allCookies.priviledge));
                setCookies(obj);
            } catch (error) {
                console.error('Error decoding privilege cookie', error);
            }
        }

        const token = window.localStorage.getItem("token");
        if (token) {
            const parseToken = token.charAt(0) === "{";
            const data = {
                Token: parseToken ? JSON.parse(token).token : token,
            };

            const md = {
                URL: "GetUserInfo",
                PostString: JSON.stringify(data),
            };

            axios.post("/central/centralcall/CallReqWithHeader", md)
                .then((res) => {
                    if (res.data.userID !== "Session is abort") {
                        //dispatch(setUserData(res?.data));
                        setUserData(res?.data);
                        setDeshBoard(!(res.data.roleID === 29 || res.data.roleID === 32));

                        if (res.data.userID > 0) {
                            window.sessionStorage.setItem("UserID", res.data.userID);
                        }
                    } else {
                        setWhatsAppBot(true);
                        window.localStorage.removeItem("token");
                    }
                });
        } else {
            setWhatsAppBot(true);
        }
    }, []);

    useEffect(() => {
        console.log(cookies, "cookies Data 2 (after state update)");
    }, [cookies]);

    const getCookies = () => {
        var cookies = document.cookie.split(';');
        var cookieMap = {};
        cookies.forEach(function (cookie) {
            var parts = cookie.split('=');
            var name = parts[0].trim();
            var value = decodeURIComponent(parts[1]);
            cookieMap[name] = value;
        });
        return cookieMap;
    };
    //useEffect(() => {
    //    if (cookies) {
    //        const hasBlockPos = cookies?.priviledgeList.some(
    //            (item) => item.PrivilegeName.toLowerCase() === "become a pos"
    //        );
    //        //console.log(hasBlockPos, "Affiliate"); // Output will be true or false
    //        setBlockPos(hasBlockPos);
    //    } else {
    //        console.log("priviledgeList is not an array or cookies is undefined");
    //    }
    //}, [cookies]);

    useEffect(() => {
        if (UserData.userID === 188452) {
            document.documentElement.style.setProperty('--Prim-Color', "#5430bb");
            document.documentElement.style.setProperty('--LightBG', "#f1f7ff");
            document.documentElement.style.setProperty('--DarkBG-BTN', "#3c17a5");
            document.documentElement.style.setProperty('--BrightnessDark', "brightness(0)");
            document.documentElement.style.setProperty('--AllImages', "grayscale(1)");
            document.documentElement.style.setProperty('--BTN-Radius', "10px");
            document.documentElement.style.setProperty('--Radio-Color', "blue");
            document.documentElement.style.setProperty('--Font-Family', "'Roboto', sans-serif");
            document.documentElement.style.setProperty('--AllImagesColor', "grayscale(0)");
        } else if (UserData.userID === 29502) {
            document.documentElement.style.setProperty('--Prim-Color', "#3F4599");
            document.documentElement.style.setProperty('--PrimeTextColor', "#161719");
            document.documentElement.style.setProperty('--SecondryTextColor', "#5F6570");
            document.documentElement.style.setProperty('--LightBG', "#eef1fabd");
            document.documentElement.style.setProperty('--DarkBG-BTN', "#30368e");
            document.documentElement.style.setProperty('--BrightnessDark', "brightness(0)");
            document.documentElement.style.setProperty('--BTN-Radius', "5px");
            document.documentElement.style.setProperty('--Radio-Color', "blue");
            document.documentElement.style.setProperty('--Font-Family', "'Poppins', sans-serif");
            document.documentElement.style.setProperty('--AllImagesColor', "grayscale(0)");
            document.documentElement.style.setProperty('--AllImagesColor1', "grayscale(1)");
            document.documentElement.style.setProperty('--ComnFontSize', "11px");
            document.documentElement.style.setProperty('--MiddFontSize', "14px");
        }
    }, [UserData]);

    return (
        <React.Fragment>
            <div className={IsHideDash === false ? "SMCbody NewUIStyle OnlyAlliance" : "SMCbody NewUIStyle"}>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition={Bounce}
                />

                <NavMenu CoockieData={cookies} Udata={UserData} />
                {showWhatsAppBot && <WhatsAppBot />}

                {/* ✅ Updated Routing */}
                <Routes>
                    <Route path="/" element={<Investment />} />
                    <Route path="/guaranteed-investment" element={<Investment inv="guaranteed" />} />
                    <Route path="/participating-plan" element={<Investment inv="participating" />} />
                    <Route path="/InvestmentQuotes" element={<SMCInvestmentQuotes />} />
                    <Route path="/InvestmentPlanDetalis" element={<InvestmentPlanDetalis />} />
                    <Route path="/TaxSaving" element={<TaxSaving />} />
                    <Route path="/ShareCode" element={<ShareCode />} />
                    <Route path="/InvestmentCompareBox" element={<InvestmentCompareBox />} />
                    <Route path="/SMCInvestmentCompare" element={<SMCInvestmentCompare />} />
                    <Route path="/investmentProposal" element={<InvestmentProposal />} />
                </Routes>
            </div>
        </React.Fragment>
    );
}

export default App;